<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid">
    <div class="row signup-page two_step_reg" v-show="show">
      <div class="col-lg-12">
        <div class="signup-page--right">
          <div class="form-help">
            <span>{{ getTranslations.visitor_sign_up_3_almost_done }}</span>
          </div>
          <div class="signup-form">
            <form action="">
              <span v-if="facebookFunctionality" class="fb_span">{{ getTranslations.visitor_sign_up_3_create_only }}</span>
              <div v-if="facebookFunctionality" class="form-group form-group--icon fb_login"
                   :class="[ !(errorInFb || hasErrorsUsernameFb)? '' : 'has-warning' ]">
                <input type="text" class="form-group__textfield"
                       :class="[ !hasErrorsUsernameFb ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_sign_up_3_placeholder_create_username"
                       @keyup="checkFb"
                       v-model="username"/>
                <span v-show="getMessage(messageForUsernameFb) && username"
                      class="form-group__feedback">{{ getMessage(messageForUsernameFb) }}</span>
                <div v-if="proposedUsername !== username" v-show="proposedUsername" class="form-group__suggestion">
                  <div class="form-group form-group--radio">
                    <input id="name1" type="radio" :value="proposedUsername"
                           v-model="username" @change="change">
                    <label for="name1">{{ proposedUsername }}</label>
                  </div>
                </div>
                <facebook-login :errorsInFb="hasErrorsUsernameFb" :enteredUsername="username" :previousComponentFacebook=this.registerPage @errorsUpdated="methodForEvent($event)" @usernameChecked="checkFbUsername($event)" @waitForCoreResponse="methodForResponse($event)"></facebook-login>
                <span v-if="errorInFb" class="form-group__feedback">{{ getFbMessage() }}</span>
              </div>
              <div v-if="facebookFunctionality" class="form-group form-group--or">
                <div><span>{{ getTranslations.visitor_sign_up_and_login_or }}</span></div>
              </div>
              <div class="form-group form-group--icon"
                   :class="[ !hasErrorsUsername ? '' : 'has-warning' ]">
                <input type="text" class="form-group__textfield"
                       :class="[ !hasErrorsUsername ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_sign_up_3_placeholder_create_username"
                       @keyup="check()"
                       v-model="user.username" maxlength="12"/>
                <span v-show="getMessage(messageForUsername)"
                      class="form-group__feedback">{{ getMessage(messageForUsername) }}</span>
                <div v-show="user.proposedUsername" class="form-group__suggestion">
                  <div class="form-group form-group--radio">
                    <input id="name2" type="radio" :value="user.proposedUsername"
                           v-model="user.username" @change="change">
                    <label for="name2">{{ user.proposedUsername }}</label>
                  </div>
                </div>
                <i class="icon-profile"></i>
              </div>
              <div class="form-group form-group--icon"
                   :class="[ !hasErrorsPassword ? '' : 'has-warning' ]">
                <input type="password" class="form-group__textfield"
                       :class="[ !hasErrorsPassword ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_sign_up_3_placeholder_create_password"
                       @keyup="checkPassword" v-model="user.password"/>
                <span v-show="getMessage(messageForPassword) && user.password"
                      class="form-group__feedback">{{ getMessage(messageForPassword) }}</span>
                <span v-show="getMessage(messageForFinalPassword)"
                      class="form-group__feedback">{{ getMessage(messageForFinalPassword) }}</span>
                <i class="icon-lock"></i>
              </div>
              <div class="form-group form-group--icon"
                   :class="[ !hasErrorsConfirmPassword ? '' : 'has-warning' ]">
                <input type="password" class="form-group__textfield"
                       :class="[ !hasErrorsConfirmPassword ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_sign_up_3_placeholder_confirm_password"
                       @keyup="checkPassword"
                       v-model="user.confirmPassword"/>
                <span v-show="getMessage(messageForConfirmPassword) && user.confirmPassword"
                      class="form-group__feedback">{{ getMessage(messageForConfirmPassword) }}</span>
                <span v-show="getMessage(finalMessage)"
                      class="form-group__feedback">{{ getMessage(finalMessage) }}</span>
                <i class="icon-lock"></i>
              </div>
              <div class="form-group form-group--checkbox">
                <input id="remember_me" type="checkbox" value="remember_me_checked" v-model="rememberMeParameter"><label
                for="remember_me">{{ getTranslations.visitor_sign_up_3_remember_me }}</label>
              </div>
              <input type="submit" :value="getTranslations.visitor_sign_up_3_submit_button_sign_up"
                     :class="['btn btn--medium btn--main', ( waitForResponse || hasErrorsUsername || hasErrorsPassword || hasErrorsConfirmPassword ) ? 'deactivated' : '']" @click.prevent="checkButton">
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import RegistrationFlowMixin from '@/common/mixins/flow';
import FacebookLogin from '.././FacebookLogin';

let words;
function readTextFile(file) {
  const rawFile = new XMLHttpRequest();
  rawFile.open('GET', file, false);
  rawFile.onreadystatechange = function read() {
    if (rawFile.readyState === 4) {
      if (rawFile.status === 200 || rawFile.status === 0) {
        words = rawFile.responseText.split('\r\n');
        // remove empty string of the last new line
        words.pop();
        // alert(words);
      }
    }
  };
  rawFile.send(null);
}

export default {
  components: { FacebookLogin },
  name: 'two-step-sign-up-2',
  mixins: [RegistrationFlowMixin],
  data() {
    return {
      show: true,
      user: {
        username: '',
        password: '',
        confirmPassword: '',
        proposedUsername: '',
      },
      proposedUsername: '',
      username: '',
      registerPage: 'register3',
      messageForUsernameFb: '',
      hasErrorsUsernameFb: false,
      errorInFb: false,
      messageForPassword: '',
      messageForUsername: '',
      messageForConfirmPassword: '',
      messageForFinalPassword: '',
      hasErrorsUsername: false,
      hasErrorsPassword: false,
      hasErrorsConfirmPassword: false,
      finalMessage: '',
      message: '',
      blacklistWords: [],
      rememberMeParameter: true,
      fbMessageUsernameError: '',
      waitForResponse: false,
    };
  },
  // eslint-disable-next-line
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.showPage(false);
      vm.checkExternalSubscription(to);
    });
  },
  created() {
    readTextFile('./static/data/username_blacklist_words.txt');
    this.blacklistWords = words;
  },
  methods: {
    ...mapMutations('profile', [
      'setRegistrationInfo',
      'setFirstTimeEntry',
    ]),
    ...mapActions('i18n', [
      'updateUserLanguage',
    ]),
    ...mapActions('profile', [
      'callForAuthorization',
      'getUserLoginDetails',
      'storeLoginInfo',
    ]),
    showPage(value) {
      this.show = value;
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslations[key] || '';
    },
    checkFbUsername(event) {
      if (event === 'Blank Username') {
        this.errorInFb = true;
        this.fbMessageUsernameError = true;
      }
    },
    getFbMessage() {
      if (!this.fbMessageUsernameError) return this.getTranslations.visitor_sign_up_3_this_fb;
      return this.getTranslations.visitor_sign_up_3_fb_username_first;
    },
    methodForEvent(event) {
      this.errorInFb = event;
    },
    methodForResponse(event) {
      this.waitForResponse = event;
    },
    checkExternalSubscription(to) {
      if (to.query.msisdn && to.query.date && to.query.lang && to.query.digest) {
        const msisdn = to.query.msisdn;
        const mergedParams = to.query[this.mergedParam] ? encodeURIComponent(to.query[this.mergedParam]) : '';
        this.$axios.get(`api/externalSubscribe?msisdn=${msisdn}&lang=${to.query.lang}&date=${encodeURIComponent(to.query.date)}&signature=${encodeURIComponent(to.query.digest)}&params=${mergedParams}`).then((response) => {
          if (response.data.responseEnum === 'OPERATION_SUCCESS') {
            if (!this.isString(response.data.data) && this.hasSimplify()) {
              if (response.data.data.result === 'SUCCESS') {
                this.storeLoginInfo({
                  token: response.data.data.token,
                  rememberMeParameter: this.rememberMeParameter,
                  username: response.data.data.username,
                });
                this.getUserLoginDetails().then(() => {
                  this.setFirstTimeEntry(true);
                  this.updateUserLanguage();
                  this.$router.push('home');
                });
              }
            }
            if (response.data.data === 'SUCCESS') {
              this.showPage(true);
              this.setRegistrationInfo(msisdn);
            } else if (response.data.data === 'ALREADY_REGISTERED') {
              this.$router.push('/login');
            } else {
              this.$router.push('/');
            }
          } else {
            this.$router.push('/');
          }
        });
      } else {
        this.showPage(true);
      }
    },
    check(evt) {
      const max = 12;
      const min = 3;
      this.messageForFinalPassword = '';
      this.hasErrorsUsername = false;
      this.finalMessage = '';
      this.errorInFb = false;
      this.messageForUsername = '';
      if (this.user.username === '') {
        this.hasErrorsUsername = false;
      } else {
        for (let i = 0; i < this.blacklistWords.length; i += 1) {
          if (this.user.username.includes(this.blacklistWords[i])) {
            this.messageForUsername = 'visitor_sign_up_3_warning_msg_username_blacklist_word';
            this.hasErrorsUsername = true;
            return;
          }
        }
        if (this.user.username.length < min) {
          this.messageForUsername = 'visitor_sign_up_3_warning_msg_username_at_least_3_chars_long';
          this.user.proposedUsername = '';
          this.hasErrorsUsername = true;
        } else {
          this.messageForUsername = '';
          if (this.user.username.length > max) {
            this.user.username = this.checkMaxChar(this.user.username, max, evt);
            this.hasErrorsUsername = true;
          }
          // eslint-disable-next-line
          const validUsernameRegex = /^(?!.*[\0\b\n\f\r\t\s-!@#\$%\=.^\&*(\+\/?\[\]|΄΄;:<>}{'"¨,)`~\\])_?.+$/;
          const validUsername = this.user.username.match(validUsernameRegex);
          this.hasErrorsUsername = false;
          if (validUsername === null) {
            this.hasErrorsUsername = true;
            this.messageForUsername = 'visitor_sign_up_3_warning_msg_username_criteria';
            return;
          }
          this.$axios.get(`publicapi/checkUsername?username=${this.user.username}&msisdn=${encodeURIComponent(this.registrationInfoMsisdn)}`).then((response) => {
            const resp = response.data.data.msg;
            if (resp === 'Username exists') {
              this.messageForUsername = 'visitor_sign_up_3_warning_msg_username_taken_below';
              this.hasErrorsUsername = true;
            } else {
              this.messageForUsername = response.data.data.msg;
            }
            this.user.proposedUsername = response.data.data.prpusn;
          });
        }
      }
    },
    checkMaxChar(value, max, evt) {
      if (value.length > max) {
        /* eslint-disable */
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode.which < 0x20) {
          // e.which < 0x20, then it's not a printable character
          // e.which === 0 - Not a character
          return;     // Do nothing
        }
        if (value.length == max) {
          charCode.preventDefault();
//            return false;
        } else if (value.length > max) {
          // Maximum exceeded
//            this.user.password = this.user.password.substring(0, max);
          return value.substring(0, max);
        }
        /* eslint-enable */
      }
    },
    checkFb(evt) {
      const max = 12;
      const min = 3;
      this.messageForFinalPassword = '';
      this.finalMessage = '';
      this.errorInFb = false;
      this.hasErrorsUsernameFb = false;
      this.messageForUsernameFb = '';
      this.fbMessageUsernameError = false;
      if (this.username === '') {
        this.hasErrorsUsernameFb = false;
      } else {
        for (let i = 0; i < this.blacklistWords.length; i += 1) {
          if (this.username.includes(this.blacklistWords[i])) {
            this.messageForUsernameFb = 'visitor_sign_up_3_warning_msg_username_blacklist_word';
            this.hasErrorsUsernameFb = true;
            return;
          }
        }
        if (this.username.length < min) {
          this.messageForUsernameFb = 'visitor_sign_up_3_warning_msg_username_at_least_3_chars_long';
          this.proposedUsername = '';
          this.hasErrorsUsernameFb = true;
        } else {
          if (this.username.length > max) {
            this.username = this.checkMaxChar(this.username, max, evt);
            this.hasErrorsUsernameFb = true;
          }
          this.hasErrorsUsernameFb = false;
          // eslint-disable-next-line
          const validUsernameRegex = /^(?!.*[\0\b\n\f\r\t\s-!@#\$%\=.^\&*(\+\/?\[\]|΄΄;:<>}{'"¨,)`~\\])_?.+$/;
          const validUsername = this.username.match(validUsernameRegex);
          if (validUsername === null) {
            this.hasErrorsUsernameFb = true;
            this.messageForUsernameFb = 'visitor_sign_up_3_warning_msg_username_criteria';
            return;
          }
          this.$axios.get(`publicapi/checkUsername?username=${this.username}&msisdn=${this.registrationInfoMsisdn}`).then((response) => {
            const resp = response.data.data.msg;
            if (resp === 'Username exists') {
              this.messageForUsernameFb = 'visitor_sign_up_3_warning_msg_username_taken_below';
              this.hasErrorsUsernameFb = true;
            } else {
              this.messageForUsernameFb = response.data.data.msg;
            }
            this.proposedUsername = response.data.data.prpusn;
          });
          this.messageForUsernameFb = '';
        }
      }
    },
    checkPassword(evt) {
      const min = 6;
      const max = 12;
      this.messageForFinalPassword = '';
      this.messageForConfirmPassword = '';
      this.messageForPassword = '';
      this.finalMessage = '';
      this.errorInFb = false;
      // eslint-disable-next-line
      const validPasswordRegex = /^(?!.*[\0\b\n\f\r\t\s-!@#\$%\=.^\&*(\+\/?\[\]|΄΄;:<>}{'"¨,)`~\\])_?.+$/;
      // const validUsernameRegex = /^[a-z0-9@]+$/i; //mono arithmous grammata kai @ /tested in regex101.com
      // ^(?=.*[a-z])(?=.*\d)(?!.*\W)_?.+$ /?! negative lockhead _?(optional _ )
      // /^(?=.*[a-z])(?=.*\d)(?=.*_).+$/
      // https://stackoverflow.com/questions/1559751/regex-to-make-sure-that-the-string-contains-at-least-one-lower-case-char-upper
      const validUsername = this.user.password.match(validPasswordRegex);
      this.hasErrorsPassword = false;
      if (this.user.password.length < min) {
        this.messageForPassword = 'visitor_sign_up_3_info_wrong_password_warning_msg_at_least_6_chars';
        this.hasErrorsPassword = true;
      } else if (this.user.password.length > max) {
        this.user.password = this.checkMaxChar(this.user.password, max, evt);
        this.hasErrorsPassword = true;
        this.checkPassword();
      } else if (validUsername !== null) {
        if (this.user.password.length > max) {
          this.user.password = this.checkMaxChar(this.user.password, max, evt);
          this.hasErrorsPassword = true;
          this.checkPassword();
        }
        this.messageForPassword = '';
        if (this.user.confirmPassword !== '' && (this.user.confirmPassword === this.user.password)) {
          this.messageForConfirmPassword = '';
          this.hasErrorsPassword = false;
          this.hasErrorsConfirmPassword = false;
        } else {
          this.messageForConfirmPassword = 'visitor_sign_up_3_passwords_do_not_match';
          this.hasErrorsPassword = false;
          this.hasErrorsConfirmPassword = true;
        }
      } else if (validUsername === null) {
        this.hasErrorsPassword = true;
        // eslint-disable-next-line
        this.messageForPassword = 'visitor_forgot_password_3_msg_password_cannot_contain_any_other_symbols_except_from_';
      }
      if (this.user.password === '') {
        this.hasErrorsPassword = false;
        this.hasErrorsConfirmPassword = false;
      } else if (this.user.confirmPassword === '') {
        this.hasErrorsConfirmPassword = false;
      }
//      if (this.hasErrorsPassword && this.user.password.length >= min) {
//        const passwordWithoutLetter = this.user.password.match(/^(?!.*[A-Za-z]).+$/);
//        const passwordWithoutNumber = this.user.password.match(/^(?!.*\d).+$/);
//        const passwordWithSymbolsExceptUnderscore = this.user.password.match(/^(?!.*\W)_?.+$/);
//        if (passwordWithoutLetter !== null) {
//          this.messageForPassword = this.getTranslations.visitor_sign_up_3_info_msg_password_does_not_contain_at_least_one_letter;
//        } else if (passwordWithoutNumber !== null) {
//          this.messageForPassword = this.getTranslations.visitor_sign_up_3_info_msg_password_does_not_contain_at_least_one_1_digit;
//        } else if (passwordWithSymbolsExceptUnderscore === null) {
//          this.messageForPassword = this.getTranslations.visitor_sign_up_3_info_msg_password_cannot_contain_any_other_symbols_except_from;
//        }
//      }
    },
    change() {
      this.user.proposedUsername = '';
      this.finalMessage = '';
      this.hasErrorsUsername = false;
      this.messageForUsername = '';
      this.errorInFb = false;
      this.messageForUsernameFb = '';
      this.hasErrorsUsernameFb = false;
      this.messageForFinalPassword = '';
    },
    loginUser(userOrMsisdn, pass) {
      this.message = '';
      const userData = {
        username: userOrMsisdn,
        password: pass,
        rememberMe: this.rememberMeParameter,
      };
      this.callForAuthorization(userData).then(() => {
        if (this.getUserAuthorized) {
          this.getUserLoginDetails().then(() => {
            this.setFirstTimeEntry(true);
            this.updateUserLanguage();
            this.$router.push('home');
            this.waitForResponse = false;
          });
        } else {
          this.message = 'SERVER_ERROR';
          this.waitForResponse = false;
        }
      });
    },
    checkButton() {
      this.errorInFb = false;
      if ((this.user.username !== '') && (this.hasErrorsPassword === false) && (this.hasErrorsUsername === false) && (this.hasErrorsConfirmPassword === false) && !(this.user.password === '') && !(this.user.confirmPassword === '')) {
        this.messageForUsername = '';
        this.waitForResponse = true;
        this.$axios.get(`api/subscribeUser?msisdn=${encodeURIComponent(this.registrationInfoMsisdn)}&username=${encodeURIComponent(this.user.username)}&password=${encodeURIComponent(this.user.password)}&lang=${encodeURIComponent(this.getLocale)}&fbReferral=${encodeURIComponent(this.fbReferral)}&freePlayPoints=${encodeURIComponent(this.registrationPoints.totalPoints || '')}`).then((responseUser) => {
          const res = responseUser.data.responseEnum;
          if (res === 'OPERATION_SUCCESS') {
            this.loginUser(this.user.username, this.user.password);
          } else {
            // eslint-disable-next-line
            if (res === 'MSISDN_INVALID') {
              this.finalMessage = 'visitor_sign_up_invalid_msisdn_msg';
            } else if (res === 'ALREADY_REGISTERED') {
              this.finalMessage = 'visitor_sign_up_msisdn_already_registered';
            } else if (res === 'MSISDN_NOT_EXIST') {
              this.finalMessage = 'visitor_sign_up_msisdn_not_exists';
            } else if (res === 'MSISDN_BLACKLISTED') {
              this.finalMessage = 'visitor_sign_up_msisdn_blacklisted';
            } else if (res === 'BLOCKED_USER') {
              this.finalMessage = 'visitor_forgot_password_warning_msd_max_attempts';
            } else if (res === 'SERVER_ERROR') {
              this.finalMessage = 'home_profile_profile_edit_server_unvailable';
            }
            this.waitForResponse = false;
          }
        });
      } else {
        // eslint-disable-next-line
        if (this.user.username === '') {
          this.hasErrorsUsername = true;
          this.messageForUsername = 'visitor_sign_up_3_fb_username_first';
        } else if (this.user.password === '') {
          this.hasErrorsPassword = true;
          this.messageForPassword = '';
          this.messageForFinalPassword = 'visitor_sign_up_3_info_wrong_password_warning_msg_at_least_6_chars';
        } else if (this.user.confirmPassword === '') {
          this.hasErrorsConfirmPassword = true;
          this.finalMessage = 'visitor_sign_up_3_passwords_do_not_match';
        }
      }
    },
  },
  computed: {
    ...mapState('common', [
      'facebookFunctionality',
      'fbReferral',
      'mergedParam',
    ]),
    ...mapState('game', [
      'registrationPoints',
    ]),
    ...mapState('profile', [
      'registrationInfoMsisdn',
    ]),
    ...mapGetters('profile', [
      'getRegistrationInfo',
      'getUserAuthorized',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/signup/TwoStepRegistration2.vue